// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vetsmith-bg {
  background: #F8F8F8;
}

.Vetsmith {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 56px;
  align-items: center;
}

.Vetsmith-item-content1.disable-mcq-btn .ant-btn {
  pointer-events: none;
  cursor: none;
}

.Vetsmith-start-btn-container.disable-start-btn .ant-btn {
  pointer-events: none;
  cursor: none;
}

.Vetsmith-Welcome-content {
  margin: 0 auto;
  max-width: 1000px;
  width: 93vw;
}

.Vetsmith-Welcome-content img.contentimage {
  min-height: 447px;
  min-width: 447px;
}

.Vetsmith-boxes {
  display: flex; 
  flex-direction: column;
  gap: 16px 16px;
  position: relative;
  padding: 10px;
}

.Vetsmith-item {
  padding: 24px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 4px;  
  display: flex;
  align-items: center;
  color: #212121;
  gap: 16px 16px;
  width: 852px;
  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -ms-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
}

.Vetsmith-item--ribbon {
  border-left: 4px solid #6C7BD4;
}

.completed-section {
  border: none !important;
  flex-direction: column;
  align-items: flex-start;
  display: block !important;
  padding: 0 !important;
}

.completed-section > .completed-section-content {
  padding: 40px 57px !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px 16px;
}

.completed-section > .Vetsmith-job-status {
  padding: 27px 57px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px 16px;
}

.Vetsmith-item .completed-title {
  color: #6C7BD4;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
}

.Vetsmith-item .completed-description {

  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #212121;
  margin-bottom: 8px;
  margin-top: -8px;
}


.Vetsmith-item-wrap {
  flex-wrap: wrap;
}

.Vetsmith-item.active {
  box-shadow: 0 4px 8px #00000029;
}

.Vetsmith-item.disabled {
  opacity: 0.5 !important;
}

.Vetsmith-item-title {
  color: #212121;
  font-size: 20px;
  font-weight: 500;
}

.Vetsmith-item-title > span {
  color: #aaaaaa;
  font-size: 20px;
  line-height: 26px;
  font-weight: normal;
  margin-left: 8px;
}

.Vetsmith-txt {
  font-size: 16px;
  line-height: 24px;
  color: #444444;
  max-width: 830px;
  margin: 30px 0;
}

.Vetsmith-welcome-banner {
  color: #212121;
  padding: 80px 0 60px;
  background: #EDEDED;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.welcome-banner-content {
  width: 852px;
}

.Vetsmith-t1, .Vetsmith-t2, .Vetsmith-t3, .Vetsmith-t4 {
  display: block;
  max-width: 952px;
}

.Vetsmith-t1 {
  font-size: 28px;
  line-height: 37px;
}

.Vetsmith-t2 {
  font-size: 50px;
  font-weight: 500;
  margin-bottom: 24px;
  line-height: 66px;
}

.Vetsmith-t3 {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 26px;
}

.Vetsmith-t4 {
  font-size: 16px;
  line-height: 21px;
  white-space: pre-line;
}


.Vetsmith-esttime {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 150px;
}

.Vetsmith-esttime-info {
  color: #212121; 
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
}

.Vetsmith-esttime-value {
  color: #56A8F7; 
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}

.Vetsmith-item.disabled .Vetsmith-esttime-value {
  color: #AAAAAA; 
}

.Vetsmith-start-btn-container {
  padding-right: 24px;
}

.Vetsmith-start-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  background: #2E6EDF 0% 0% no-repeat padding-box;
  box-shadow: 0 2px 4px #00000014;
  border-radius: 4px;
  border-color: #2E6EDF;
  padding: 9px 20px;
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
  gap: 10px;
}

.Vetsmith-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 9px 24px;
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0 2px 4px #00000014;
  border: 1px solid #666666;
  border-radius: 4px;
  color: #666666;
}

.Vetsmith-upload > svg {
  margin-right: 10px;
  margin-left: -5px;
}

.Vetsmith-footer {
  padding: 40px 0;
}

.Vetsmith-footer > div {
  display: flex;
  align-items: center;
  gap: 41px;
}
.Vetsmith-footer > div > span { 
  text-align: center;
  flex: 1;
}
.Vetsmith-footer > div > * {
  color: #888888;
  text-decoration: none;
  font-size: 14px;
  line-height: 19px;
}

.Vetsmith-welcome-banner  .Vetsmith-logo {
  color: #fff;
  float: right;
  width: 150px;
}

.Vetsmith-item-content {
  flex: 1;
  max-width: 600px;
  min-width: 393px;
}

.Vetsmith-item-content:first-child {
  max-width: 565px;
  padding-left: 15px;
}

.Vetsmith-item-num {
  color: #eeeeee;
  font-size: 50px;
  line-height: 50px;
  width: 70px;
  text-align: center;
  padding-right: 10px;
}

.Vetsmith-item.disabled .Vetsmith-start-btn,
.Vetsmith-item.disabled .Vetsmith-scheduled,
.Vetsmith-item.disabled .Vetsmith-item-status,
.Vetsmith-item.disabled .Vetsmith-upload {
  display: none;  
}

.Vetsmith-item-status {
  font-size: 14px;
  line-height: 19px;
  text-align: right;
}

.Vetsmith-item-status-passed {
  color: #66CC80;
}

.Vetsmith-item-status-didntpass {
  color: #aaaaaa;
}

.Vetsmith-item-status > img {
  margin-right: 5px;
  vertical-align: text-top;
}

.Vetsmith-start-btn {
  border: none;
}

.Vetsmith-scheduled {
  color: #56A8F7;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.Vetsmith-modal .ant-modal-header {
  border-bottom: none;
}

.Vetsmith-modal .ant-modal-title {
  font-size: 28px;
  color: #212121;
  font-weight: 500;
  line-height: 37px;
}

.Vetsmith-modal .ant-modal-footer {
  border-top: none;
}

.Vetsmith-modal  .ant-modal-content {
  padding: 20px;
}

.Vetsmith-modal .ant-btn, .Vetsmith-modal .ant-btn:hover {
  background-color: #ffffff;
  color: #2E6EDF;
  border: 1px solid #2E6EDF;
}


.Vetsmith-modal .ant-btn-primary, .Vetsmith-modal .ant-btn-primary:hover {
  background-color: #2E6EDF;
  color: #ffffff;
}

.Vetsmith-tag {
  color: #AAAAAA;
  font-size: 14px;
  line-height: 21px;
  background: #EEEEEE 0% 0% no-repeat padding-box;
  border-radius: 11px;
  padding: 2px 5px;
}

.Vetsmith-upload-box {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.Vetsmith-upload-filename {
  color: #666666;
  display: flex;
  gap: 10px;
}

@media only screen and (max-width: 900px) {

  .Vetsmith-t1 {
    font-size: 20px;
    line-height: 26px;
  }
  
  .Vetsmith-t2 {
    font-size: 34px;
    font-weight: 500;
    margin-bottom: 16px;
    line-height: 45px;
  }
  
  .Vetsmith-t3 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
    line-height: 24px;
  }
  
  .Vetsmith-t4 {
    font-size: 14px;
    line-height: 22px;
  }

  .Vetsmith-welcome-banner .Vetsmith-logo{
    margin-top: -50px;
  }

  .Vetsmith-item {
    flex-wrap: wrap;
    justify-content: space-between;
    min-width: initial !important;
  }

  .Vetsmith-item-content {
    min-width: 86%;
    max-width: initial !important;
  }

  .Vetsmith-start-btn-container {
    padding-right: 0 !important;
  }

  .Vetsmith-esttime {
    min-width: 110px;
    margin-left: 29px;
  }

  .Vetsmith-item-num {
    width: 39px;
  }

  .Vetsmith-welcome-banner .Vetsmith-content{
    max-width: 85vw;
  }  

  .welcome-banner-content  {
    min-width: 85vw !important;
  }
}

.Vetsmith-opt-out {
  display: flex;
  align-items: center;
  gap: 16px;
}

.Vetsmith-opt-out p {
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  color: #666666;
}

@media only screen and (max-width: 600px) {
  .Vetsmith-item-content {
    min-width: 70% !important;
  }
}

@keyframes Anim1 { 
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.Vetsmith-boxes {
  margin-top: -80px;
}

.Vetsmith-boxes > div {
  transform: translateX(-20px);
  animation: Anim1 0.2s linear;
  animation-fill-mode: both;
}

.Vetsmith-boxes > div:nth-child(1) { animation-delay: .2s }
.Vetsmith-boxes > div:nth-child(2) { animation-delay: .4s }
.Vetsmith-boxes > div:nth-child(3) { animation-delay: .6s }
.Vetsmith-boxes > div:nth-child(4) { animation-delay: .8s }
.Vetsmith-boxes > div:nth-child(5) { animation-delay: 1s }
.Vetsmith-boxes > div:nth-child(6) { animation-delay: 1.2s }


@keyframes Anim2 { 
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.Vetsmith-t1,
.Vetsmith-t2,
.Vetsmith-t3,
.Vetsmith-t4 {
  transform: translateY(-20px);
  animation: Anim2 0.1s linear;
  animation-fill-mode: both;
}

.Vetsmith-t1 { animation-delay: .1s }
.Vetsmith-t2 { animation-delay: .2s }
.Vetsmith-t3 { animation-delay: .3s }
.Vetsmith-t4 { animation-delay: .4s }

.Vetsmith-status {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: flex-end;
}

.Vetsmith-Completed, .Vetsmith-DidDidntPass {
  display: flex;
  gap: 7px;
  align-items: center;
}

.Vetsmith-Completed > span {
  color: #66CC80;
}

.Vetsmith-DidDidntPass > span{
  color: #F86567;
}

.Vetsmith-status > button, .completed-section button {
  background-color: #2E6EDF !important;
  display: flex;
  gap: 10px;
  align-items: center;
}

.Vetsmith-status .profile-update-btn {
  background-color: white !important;
  border-color: #2E6EDF !important;
  color: #2E6EDF !important;
}

.ins-content {
  padding-bottom: 20px;
  padding-top: 25px;
}

.Instructions-btn {
  position: absolute;
  color: #2E6EDF;
  display: flex;
  gap: 12px;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  font-weight: 500;
}

.Instructions-body button {
  border-color: #2E6EDF !important;
  background-color: #fff;
  color: #2E6EDF !important;
}

.Instructions-body button.ant-btn-primary {
  background-color: #2E6EDF !important;
  color: #fff !important;
}

.Instructions-body {
  display: flex;
  align-items: center;
  padding: 30px;
  gap: 20px;
}

.Instructions-body > div {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
  justify-content: space-between;
}

.Instructions-body h1 {
  color: #212121;
  font-size: 36px;
  line-height: 42px;
  font-weight: 500;
}

.Instructions-body h2 {
  color: #212121;
  font-size: 29px;
  line-height: 34px;
  letter-spacing: 0.25px;
  font-weight: 500;
}

.Instructions-body p {
  color: #212121;
  
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
}

.Instructions-body .imageHolder {
  align-items: flex-end;
}


.Instructions-body img.contentimage {
  max-width: 447px;
}

.flows-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.flows-list > div {
  cursor: pointer;
  color: #2E6EDF;
  
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.flows-list > div > div {
  flex: 1;
  display: flex;
  gap: 15px;
}


.flows-list .flow-name {
  min-width: 250px;
}

.Vetsmith-btn-list {
  display: flex;
  gap: 20px;
  align-items: center;
}

.Vetsmith-NoFlow-content .Instructions-body {
  gap: 30px;
  padding: 50px 146px;
}

.Vetsmith-NoFlow-turing-logo {
  margin-bottom: 70px;
  display: inline-block;
}

.Vetsmith-opt-out {
  display: flex;
  gap: 15px;
  align-items: center;
}

.Vetsmith-opt-out > button {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 11px !important;
  color: #CF2020 !important;
}

.Vetsmith-boxes > hr {
  width: 100%;
  opacity: 0.5;
}

.Vetsmith-btn-back {
  color: #2E6EDF !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 11px !important;
  margin-bottom: 30px;
  margin-top: -15px;
}

.Vetsmith-modal-opt-out .anticon-exclamation-circle,
.Vetsmith-modal-opt-out .ant-modal-confirm-title {
  font-size: 20px !important;
  color:#F86567 !important;
}

.Vetsmith-modal-opt-out .ant-modal-confirm-title {
  font-weight: 500;
  line-height: 26.62px;
}

.Vetsmith-modal-opt-out .ant-modal-confirm-content {
  font-size: 14px;
  line-height: 20px;
}

.Vetsmith-modal-opt-out .ant-btn-primary,
.Vetsmith-modal-opt-out .ant-btn-primary:active,
.Vetsmith-modal-opt-out .ant-btn-primary:focus {
  background-color:#F86567 !important;
}

.Vetsmith-VetsmithCompleteCard-content img.contentimage{
  min-height: 620px;
  min-width: 620px;
}

 .create-password-modal {
  display: flex;
  flex-direction: column;
  gap: 15;
 }

 
 .create-password-modal .ant-form-item-required {
  padding-right: 10px;
  position: relative;
}

 .create-password-modal .ant-form-item-required::after {
  display: none !important;
}

 .create-password-modal .ant-form-item-required::before {
  position: absolute;
  position: absolute;
  right: -5px;
  top: 1px;
}

.password-modal .ant-modal-header {
  border-bottom: none !important;
  padding-top: 32px;
}

.password-modal .ant-modal-footer {
  border-top: none !important;
  padding-bottom: 24px;
}

.password-modal .ant-modal-title {
  color: #212121;
  font-size: 20px;
  line-height: 27px;
  font-weight: 500;
}

.password-modal .ant-modal-body {
  padding-top: 0;
}

.create-password-modal input {
  padding: 10px;
}

.create-password-modal .ant-form-explain {
  font-size: 12px;
  color: #888888;
  margin-top: 4px;
}

.Vetsmith-job-status {
  border-top: 1px solid #DDDDDD;
}

.Vetsmith-job-status-title {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.15px;
  color: #212121;
}

.Vetsmith-job-status-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px 6px 8px;
  background: #F8F8F8;
  border-radius: 6px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #444444;
  gap: 5px;
}

.VetsmithSubscribe {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Vetsmith-ws {
  white-space: pre-line;
}

.hyperlink-list {
  display: grid;
  grid-template-columns: 1fr 14fr 8fr 8fr;
  gap: 8px 8px;
  grid-auto-flow: row;
  margin-left: 88px;
}

.hyperlink-list > div {
  display: flex;
  align-items: center;
}

.hyperlink-list button {
  display: flex;
  gap: 3px;
  align-items: center;
}

.hyperlink-link-num, .hyperlink-link-title {

  font-size: 16px;
  font-weight: 500;
  color: #212121;
}

.hyperlink-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px;
  gap: 10px; 
  height: 32px;
  background: #F8F8F8;
  border-radius: 6px;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #444444;
}

.hyperlink-viewed {
  background: #E0F5E6;
  color: #1F5C2E;
}

.ant-spin-spinning {
  display: flex !important;
  justify-content: center !important;
}

.fileupload-list {
  display: flex;
  flex-direction: column;
  margin-left: 88px;
}

.fileupload-list > div {
  display: flex;
  align-items: center;
}

.flieupload-list-start-upload {
  display: flex;
  gap: 20px;
  align-items: center;
  padding-top: 15px;
  padding-left: 88px;
}

.flieupload-list-start-upload button {
  display: flex;
  align-items: center;
  gap: 5px;
}

.fileupload-list-view-mode {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap; 
  margin-left: 88px; 
  gap: 15px;
}

.fileupload-list-view-mode > div {
  display: flex;
  align-items: center;
}

.fileupload-list-view-mode span {
  padding-left: 10px;
}


.file-upload-item {
  display: flex;
  gap: 15px;
  font-size: 16px;
  padding: 6px;
}

.file-upload-number {
  font-weight: 500;
  max-width: 10px;
}

.file-upload-title {
  width: 150px;
  margin-top: -3px;
}

.file-upload-button {
  margin-left: 50px;
}

.file-upload-button-inner {
  display: flex !important;
  gap: 6px;
  font-size: 14px;
}

.file-upload-status {
  margin-left: 25px;
  width: 150px;
  margin-top: -3px;
}

.file-upload-select-button {
  margin-top: 3px;
  font-weight: 500;
  font-size: 14px;
}

.file-upload-delete-file {
  color: black;
}

.file-upload-underline {
  border-bottom: solid #EDEDED 1px;
}

.file-upload-status--truncate {
  width: 12.4ch;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}

.file-upload-delete-btn .ant-btn {
  padding: 0;
}

.uploaded-file-name--truncate {
  width: 60.4ch;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  white-space: nowrap;
}

.uploaded-file-details {
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/Vetsmith/Vetsmith.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,+CAA+C;EAC/C,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,qCAAqC,qBAAqB;AAC1D,qCAAqC,qBAAqB;AAC1D,qCAAqC,qBAAqB;AAC1D,qCAAqC,qBAAqB;AAC1D,qCAAqC,oBAAoB;AACzD,qCAAqC,sBAAsB;;;AAG3D;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;EAIE,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,eAAe,qBAAqB;AACpC,eAAe,qBAAqB;AACpC,eAAe,qBAAqB;AACpC,eAAe,qBAAqB;;AAEpC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;;EAEd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,SAAS;AACX;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;CAEC;EACC,aAAa;EACb,sBAAsB;EACtB,OAAO;CACR;;;CAGA;EACC,mBAAmB;EACnB,kBAAkB;AACpB;;CAEC;EACC,wBAAwB;AAC1B;;CAEC;EACC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".Vetsmith-bg {\n  background: #F8F8F8;\n}\n\n.Vetsmith {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  gap: 56px;\n  align-items: center;\n}\n\n.Vetsmith-item-content1.disable-mcq-btn .ant-btn {\n  pointer-events: none;\n  cursor: none;\n}\n\n.Vetsmith-start-btn-container.disable-start-btn .ant-btn {\n  pointer-events: none;\n  cursor: none;\n}\n\n.Vetsmith-Welcome-content {\n  margin: 0 auto;\n  max-width: 1000px;\n  width: 93vw;\n}\n\n.Vetsmith-Welcome-content img.contentimage {\n  min-height: 447px;\n  min-width: 447px;\n}\n\n.Vetsmith-boxes {\n  display: flex; \n  flex-direction: column;\n  gap: 16px 16px;\n  position: relative;\n  padding: 10px;\n}\n\n.Vetsmith-item {\n  padding: 24px;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border-radius: 4px;  \n  display: flex;\n  align-items: center;\n  color: #212121;\n  gap: 16px 16px;\n  width: 852px;\n  -webkit-transition: all 200ms ease-in-out;\n  -moz-transition: all 200ms ease-in-out;\n  -ms-transition: all 200ms ease-in-out;\n  -o-transition: all 200ms ease-in-out;\n  transition: all 200ms ease-in-out;\n}\n\n.Vetsmith-item--ribbon {\n  border-left: 4px solid #6C7BD4;\n}\n\n.completed-section {\n  border: none !important;\n  flex-direction: column;\n  align-items: flex-start;\n  display: block !important;\n  padding: 0 !important;\n}\n\n.completed-section > .completed-section-content {\n  padding: 40px 57px !important;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px 16px;\n}\n\n.completed-section > .Vetsmith-job-status {\n  padding: 27px 57px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px 16px;\n}\n\n.Vetsmith-item .completed-title {\n  color: #6C7BD4;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n}\n\n.Vetsmith-item .completed-description {\n\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: #212121;\n  margin-bottom: 8px;\n  margin-top: -8px;\n}\n\n\n.Vetsmith-item-wrap {\n  flex-wrap: wrap;\n}\n\n.Vetsmith-item.active {\n  box-shadow: 0 4px 8px #00000029;\n}\n\n.Vetsmith-item.disabled {\n  opacity: 0.5 !important;\n}\n\n.Vetsmith-item-title {\n  color: #212121;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.Vetsmith-item-title > span {\n  color: #aaaaaa;\n  font-size: 20px;\n  line-height: 26px;\n  font-weight: normal;\n  margin-left: 8px;\n}\n\n.Vetsmith-txt {\n  font-size: 16px;\n  line-height: 24px;\n  color: #444444;\n  max-width: 830px;\n  margin: 30px 0;\n}\n\n.Vetsmith-welcome-banner {\n  color: #212121;\n  padding: 80px 0 60px;\n  background: #EDEDED;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.welcome-banner-content {\n  width: 852px;\n}\n\n.Vetsmith-t1, .Vetsmith-t2, .Vetsmith-t3, .Vetsmith-t4 {\n  display: block;\n  max-width: 952px;\n}\n\n.Vetsmith-t1 {\n  font-size: 28px;\n  line-height: 37px;\n}\n\n.Vetsmith-t2 {\n  font-size: 50px;\n  font-weight: 500;\n  margin-bottom: 24px;\n  line-height: 66px;\n}\n\n.Vetsmith-t3 {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  line-height: 26px;\n}\n\n.Vetsmith-t4 {\n  font-size: 16px;\n  line-height: 21px;\n  white-space: pre-line;\n}\n\n\n.Vetsmith-esttime {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-width: 150px;\n}\n\n.Vetsmith-esttime-info {\n  color: #212121; \n  font-size: 14px;\n  font-weight: 500;\n  line-height: 19px;\n}\n\n.Vetsmith-esttime-value {\n  color: #56A8F7; \n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n}\n\n.Vetsmith-item.disabled .Vetsmith-esttime-value {\n  color: #AAAAAA; \n}\n\n.Vetsmith-start-btn-container {\n  padding-right: 24px;\n}\n\n.Vetsmith-start-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: #fff;\n  background: #2E6EDF 0% 0% no-repeat padding-box;\n  box-shadow: 0 2px 4px #00000014;\n  border-radius: 4px;\n  border-color: #2E6EDF;\n  padding: 9px 20px;\n  font-size: 14px;\n  line-height: 19px;\n  cursor: pointer;\n  gap: 10px;\n}\n\n.Vetsmith-upload {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 9px 24px;\n  font-size: 14px;\n  line-height: 19px;\n  cursor: pointer;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  box-shadow: 0 2px 4px #00000014;\n  border: 1px solid #666666;\n  border-radius: 4px;\n  color: #666666;\n}\n\n.Vetsmith-upload > svg {\n  margin-right: 10px;\n  margin-left: -5px;\n}\n\n.Vetsmith-footer {\n  padding: 40px 0;\n}\n\n.Vetsmith-footer > div {\n  display: flex;\n  align-items: center;\n  gap: 41px;\n}\n.Vetsmith-footer > div > span { \n  text-align: center;\n  flex: 1;\n}\n.Vetsmith-footer > div > * {\n  color: #888888;\n  text-decoration: none;\n  font-size: 14px;\n  line-height: 19px;\n}\n\n.Vetsmith-welcome-banner  .Vetsmith-logo {\n  color: #fff;\n  float: right;\n  width: 150px;\n}\n\n.Vetsmith-item-content {\n  flex: 1;\n  max-width: 600px;\n  min-width: 393px;\n}\n\n.Vetsmith-item-content:first-child {\n  max-width: 565px;\n  padding-left: 15px;\n}\n\n.Vetsmith-item-num {\n  color: #eeeeee;\n  font-size: 50px;\n  line-height: 50px;\n  width: 70px;\n  text-align: center;\n  padding-right: 10px;\n}\n\n.Vetsmith-item.disabled .Vetsmith-start-btn,\n.Vetsmith-item.disabled .Vetsmith-scheduled,\n.Vetsmith-item.disabled .Vetsmith-item-status,\n.Vetsmith-item.disabled .Vetsmith-upload {\n  display: none;  \n}\n\n.Vetsmith-item-status {\n  font-size: 14px;\n  line-height: 19px;\n  text-align: right;\n}\n\n.Vetsmith-item-status-passed {\n  color: #66CC80;\n}\n\n.Vetsmith-item-status-didntpass {\n  color: #aaaaaa;\n}\n\n.Vetsmith-item-status > img {\n  margin-right: 5px;\n  vertical-align: text-top;\n}\n\n.Vetsmith-start-btn {\n  border: none;\n}\n\n.Vetsmith-scheduled {\n  color: #56A8F7;\n  font-size: 14px;\n  line-height: 19px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.Vetsmith-modal .ant-modal-header {\n  border-bottom: none;\n}\n\n.Vetsmith-modal .ant-modal-title {\n  font-size: 28px;\n  color: #212121;\n  font-weight: 500;\n  line-height: 37px;\n}\n\n.Vetsmith-modal .ant-modal-footer {\n  border-top: none;\n}\n\n.Vetsmith-modal  .ant-modal-content {\n  padding: 20px;\n}\n\n.Vetsmith-modal .ant-btn, .Vetsmith-modal .ant-btn:hover {\n  background-color: #ffffff;\n  color: #2E6EDF;\n  border: 1px solid #2E6EDF;\n}\n\n\n.Vetsmith-modal .ant-btn-primary, .Vetsmith-modal .ant-btn-primary:hover {\n  background-color: #2E6EDF;\n  color: #ffffff;\n}\n\n.Vetsmith-tag {\n  color: #AAAAAA;\n  font-size: 14px;\n  line-height: 21px;\n  background: #EEEEEE 0% 0% no-repeat padding-box;\n  border-radius: 11px;\n  padding: 2px 5px;\n}\n\n.Vetsmith-upload-box {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.Vetsmith-upload-filename {\n  color: #666666;\n  display: flex;\n  gap: 10px;\n}\n\n@media only screen and (max-width: 900px) {\n\n  .Vetsmith-t1 {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  \n  .Vetsmith-t2 {\n    font-size: 34px;\n    font-weight: 500;\n    margin-bottom: 16px;\n    line-height: 45px;\n  }\n  \n  .Vetsmith-t3 {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    line-height: 24px;\n  }\n  \n  .Vetsmith-t4 {\n    font-size: 14px;\n    line-height: 22px;\n  }\n\n  .Vetsmith-welcome-banner .Vetsmith-logo{\n    margin-top: -50px;\n  }\n\n  .Vetsmith-item {\n    flex-wrap: wrap;\n    justify-content: space-between;\n    min-width: initial !important;\n  }\n\n  .Vetsmith-item-content {\n    min-width: 86%;\n    max-width: initial !important;\n  }\n\n  .Vetsmith-start-btn-container {\n    padding-right: 0 !important;\n  }\n\n  .Vetsmith-esttime {\n    min-width: 110px;\n    margin-left: 29px;\n  }\n\n  .Vetsmith-item-num {\n    width: 39px;\n  }\n\n  .Vetsmith-welcome-banner .Vetsmith-content{\n    max-width: 85vw;\n  }  \n\n  .welcome-banner-content  {\n    min-width: 85vw !important;\n  }\n}\n\n.Vetsmith-opt-out {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.Vetsmith-opt-out p {\n  margin: 0;\n  font-size: 16px;\n  line-height: 24px;\n  color: #666666;\n}\n\n@media only screen and (max-width: 600px) {\n  .Vetsmith-item-content {\n    min-width: 70% !important;\n  }\n}\n\n@keyframes Anim1 { \n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.Vetsmith-boxes {\n  margin-top: -80px;\n}\n\n.Vetsmith-boxes > div {\n  transform: translateX(-20px);\n  animation: Anim1 0.2s linear;\n  animation-fill-mode: both;\n}\n\n.Vetsmith-boxes > div:nth-child(1) { animation-delay: .2s }\n.Vetsmith-boxes > div:nth-child(2) { animation-delay: .4s }\n.Vetsmith-boxes > div:nth-child(3) { animation-delay: .6s }\n.Vetsmith-boxes > div:nth-child(4) { animation-delay: .8s }\n.Vetsmith-boxes > div:nth-child(5) { animation-delay: 1s }\n.Vetsmith-boxes > div:nth-child(6) { animation-delay: 1.2s }\n\n\n@keyframes Anim2 { \n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.Vetsmith-t1,\n.Vetsmith-t2,\n.Vetsmith-t3,\n.Vetsmith-t4 {\n  transform: translateY(-20px);\n  animation: Anim2 0.1s linear;\n  animation-fill-mode: both;\n}\n\n.Vetsmith-t1 { animation-delay: .1s }\n.Vetsmith-t2 { animation-delay: .2s }\n.Vetsmith-t3 { animation-delay: .3s }\n.Vetsmith-t4 { animation-delay: .4s }\n\n.Vetsmith-status {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.Vetsmith-Completed, .Vetsmith-DidDidntPass {\n  display: flex;\n  gap: 7px;\n  align-items: center;\n}\n\n.Vetsmith-Completed > span {\n  color: #66CC80;\n}\n\n.Vetsmith-DidDidntPass > span{\n  color: #F86567;\n}\n\n.Vetsmith-status > button, .completed-section button {\n  background-color: #2E6EDF !important;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.Vetsmith-status .profile-update-btn {\n  background-color: white !important;\n  border-color: #2E6EDF !important;\n  color: #2E6EDF !important;\n}\n\n.ins-content {\n  padding-bottom: 20px;\n  padding-top: 25px;\n}\n\n.Instructions-btn {\n  position: absolute;\n  color: #2E6EDF;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  white-space: nowrap;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.Instructions-body button {\n  border-color: #2E6EDF !important;\n  background-color: #fff;\n  color: #2E6EDF !important;\n}\n\n.Instructions-body button.ant-btn-primary {\n  background-color: #2E6EDF !important;\n  color: #fff !important;\n}\n\n.Instructions-body {\n  display: flex;\n  align-items: center;\n  padding: 30px;\n  gap: 20px;\n}\n\n.Instructions-body > div {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.Instructions-body h1 {\n  color: #212121;\n  font-size: 36px;\n  line-height: 42px;\n  font-weight: 500;\n}\n\n.Instructions-body h2 {\n  color: #212121;\n  font-size: 29px;\n  line-height: 34px;\n  letter-spacing: 0.25px;\n  font-weight: 500;\n}\n\n.Instructions-body p {\n  color: #212121;\n  \n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.1px;\n}\n\n.Instructions-body .imageHolder {\n  align-items: flex-end;\n}\n\n\n.Instructions-body img.contentimage {\n  max-width: 447px;\n}\n\n.flows-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.flows-list > div {\n  cursor: pointer;\n  color: #2E6EDF;\n  \n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: 0.1px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.flows-list > div > div {\n  flex: 1;\n  display: flex;\n  gap: 15px;\n}\n\n\n.flows-list .flow-name {\n  min-width: 250px;\n}\n\n.Vetsmith-btn-list {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.Vetsmith-NoFlow-content .Instructions-body {\n  gap: 30px;\n  padding: 50px 146px;\n}\n\n.Vetsmith-NoFlow-turing-logo {\n  margin-bottom: 70px;\n  display: inline-block;\n}\n\n.Vetsmith-opt-out {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.Vetsmith-opt-out > button {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  padding: 11px !important;\n  color: #CF2020 !important;\n}\n\n.Vetsmith-boxes > hr {\n  width: 100%;\n  opacity: 0.5;\n}\n\n.Vetsmith-btn-back {\n  color: #2E6EDF !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  padding: 11px !important;\n  margin-bottom: 30px;\n  margin-top: -15px;\n}\n\n.Vetsmith-modal-opt-out .anticon-exclamation-circle,\n.Vetsmith-modal-opt-out .ant-modal-confirm-title {\n  font-size: 20px !important;\n  color:#F86567 !important;\n}\n\n.Vetsmith-modal-opt-out .ant-modal-confirm-title {\n  font-weight: 500;\n  line-height: 26.62px;\n}\n\n.Vetsmith-modal-opt-out .ant-modal-confirm-content {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Vetsmith-modal-opt-out .ant-btn-primary,\n.Vetsmith-modal-opt-out .ant-btn-primary:active,\n.Vetsmith-modal-opt-out .ant-btn-primary:focus {\n  background-color:#F86567 !important;\n}\n\n.Vetsmith-VetsmithCompleteCard-content img.contentimage{\n  min-height: 620px;\n  min-width: 620px;\n}\n\n .create-password-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 15;\n }\n\n \n .create-password-modal .ant-form-item-required {\n  padding-right: 10px;\n  position: relative;\n}\n\n .create-password-modal .ant-form-item-required::after {\n  display: none !important;\n}\n\n .create-password-modal .ant-form-item-required::before {\n  position: absolute;\n  position: absolute;\n  right: -5px;\n  top: 1px;\n}\n\n.password-modal .ant-modal-header {\n  border-bottom: none !important;\n  padding-top: 32px;\n}\n\n.password-modal .ant-modal-footer {\n  border-top: none !important;\n  padding-bottom: 24px;\n}\n\n.password-modal .ant-modal-title {\n  color: #212121;\n  font-size: 20px;\n  line-height: 27px;\n  font-weight: 500;\n}\n\n.password-modal .ant-modal-body {\n  padding-top: 0;\n}\n\n.create-password-modal input {\n  padding: 10px;\n}\n\n.create-password-modal .ant-form-explain {\n  font-size: 12px;\n  color: #888888;\n  margin-top: 4px;\n}\n\n.Vetsmith-job-status {\n  border-top: 1px solid #DDDDDD;\n}\n\n.Vetsmith-job-status-title {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.Vetsmith-job-status-status {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 6px 12px 6px 8px;\n  background: #F8F8F8;\n  border-radius: 6px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #444444;\n  gap: 5px;\n}\n\n.VetsmithSubscribe {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Vetsmith-ws {\n  white-space: pre-line;\n}\n\n.hyperlink-list {\n  display: grid;\n  grid-template-columns: 1fr 14fr 8fr 8fr;\n  gap: 8px 8px;\n  grid-auto-flow: row;\n  margin-left: 88px;\n}\n\n.hyperlink-list > div {\n  display: flex;\n  align-items: center;\n}\n\n.hyperlink-list button {\n  display: flex;\n  gap: 3px;\n  align-items: center;\n}\n\n.hyperlink-link-num, .hyperlink-link-title {\n\n  font-size: 16px;\n  font-weight: 500;\n  color: #212121;\n}\n\n.hyperlink-status {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 6px 12px;\n  gap: 10px; \n  height: 32px;\n  background: #F8F8F8;\n  border-radius: 6px;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  color: #444444;\n}\n\n.hyperlink-viewed {\n  background: #E0F5E6;\n  color: #1F5C2E;\n}\n\n.ant-spin-spinning {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.fileupload-list {\n  display: flex;\n  flex-direction: column;\n  margin-left: 88px;\n}\n\n.fileupload-list > div {\n  display: flex;\n  align-items: center;\n}\n\n.flieupload-list-start-upload {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  padding-top: 15px;\n  padding-left: 88px;\n}\n\n.flieupload-list-start-upload button {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.fileupload-list-view-mode {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap; \n  margin-left: 88px; \n  gap: 15px;\n}\n\n.fileupload-list-view-mode > div {\n  display: flex;\n  align-items: center;\n}\n\n.fileupload-list-view-mode span {\n  padding-left: 10px;\n}\n\n\n.file-upload-item {\n  display: flex;\n  gap: 15px;\n  font-size: 16px;\n  padding: 6px;\n}\n\n.file-upload-number {\n  font-weight: 500;\n  max-width: 10px;\n}\n\n.file-upload-title {\n  width: 150px;\n  margin-top: -3px;\n}\n\n.file-upload-button {\n  margin-left: 50px;\n}\n\n.file-upload-button-inner {\n  display: flex !important;\n  gap: 6px;\n  font-size: 14px;\n}\n\n.file-upload-status {\n  margin-left: 25px;\n  width: 150px;\n  margin-top: -3px;\n}\n\n.file-upload-select-button {\n  margin-top: 3px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.file-upload-delete-file {\n  color: black;\n}\n\n.file-upload-underline {\n  border-bottom: solid #EDEDED 1px;\n}\n\n.file-upload-status--truncate {\n  width: 12.4ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n}\n\n.file-upload-delete-btn .ant-btn {\n  padding: 0;\n}\n\n.uploaded-file-name--truncate {\n  width: 60.4ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  white-space: nowrap;\n}\n\n.uploaded-file-details {\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
